// @ts-check
import React from 'react'
import cn from 'classnames'
import styles from './style.css'
import { Header } from '../Form/Header'

/**
 * @param {{
 * caption: string,
 * children: React.ReactChild,
 * text: string
 * className?: string}} props
 */
const Page = ({ children, caption, text, className }) => {
  return (
    <div className={cn(styles.page, className)}>
      <Header title={caption}>{text}</Header>
      {children}
    </div>
  )
}

export { Page }
